<template>
  <v-row justify="center">
    <v-dialog
      v-model="value"
      persistent
      max-width="950px"
    >
      <v-card>
        <v-card-title class="headline">
         {{dialogObj.title || 'Alert!!!'}}
        </v-card-title>
        <v-card-text>
         <div v-if="dialogObj.isSubTHtml" v-html="dialogObj.subtitle"></div>
         <span v-else>{{dialogObj.subtitle || 'Are You Sure want to proceed ?'}}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :loading="dialogObj.isLoadingNo"
            @click="onClickAction(false)" v-if="dialogObj.isNo"
          >
            {{dialogObj.rejectName || 'No'}}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="dialogObj.isLoadingYes"
            @click="onClickAction(true)"
          >
            {{dialogObj.acceptName || 'Yes'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'DialogAlert',
  props: { dialogObj: {
    type: Object,
    default: () => {
      return {
        id: '',
        title: '',
        acceptName: '',
        rejectName: '',
        subtitle: '',
        show: false,
        params: {},
        isLoadingYes: false,
        isLoadingNo: false,
        isNo: true,
        isSubTHtml: false
      }
    }
  },
  value: {
    type: Boolean,
    default: false
  }
  },
  methods: {
    onClickAction (isAccept) {
      console.log(isAccept) // someValue
      this.$emit('clicked', { dialog: this.dialogObj, isSuccess: isAccept })
    }
  }
}
</script>
